import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Tooltip from "./Tooltip";
import {
  allMetalordNFTContractsDeployed,
  isSupportedNFT,
} from "../NftMarketPage/contractData";
import { ethers } from "ethers";
import { convertedMulPrice } from "../../../config/common";
import ConfirmPopup from "../../../Components/ConfirmPopup";

import {
  getTokenOfOwnerByIndex,
} from "../../Pool/nftContractData";
import {
  nftContractABI,
  metaspaceNFTMarketplaceAddress,
} from "../../../config/data";
import { balanceOf } from "../../../config/provider";
import {
  isApprovedForAll,
  setApprovalForAll,
  listNFT,
} from "./contractData";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import environmentVariables from "../../../config/environmentVariables";
import { userInfoContext } from "../../../context/userInfoContext";
import searchicon from '../../../Images/Icons/searchicon.png'
import { toast } from "react-toastify";
const NftnotfoundImg = `${environmentVariables?.cdnUrl}notification_bg.png`
import CategoriesFilter from "../NftCategories/CategoriesFilter.js";
import {
  FilterContainer,
  FilterWrapper,
  H1,
  H2,
  Link,
  NavSection,
  NavSectionWrapper,
  PriceButtonContainer,
  SearchIcon,
  SearchInput,
  SearchWrapper,
} from "../NftCategories/Styled.js";
const ListedIcon     = `${environmentVariables?.cdnUrl}listedicon.png`
const StakedIcon     = `${environmentVariables?.cdnUrl}stakedicon.png`
const Root = styled.div`
  margin: 40px 0;
  margin-top: 0;
`;
const NftnotfoundMain = styled.div`
  background-image: url(${NftnotfoundImg});
  background-repeat: no-repeat;
  margin-top: 0px;
  height: 513px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 46px;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  text-transform: uppercase;
  background-position: center;
`;
const Nftnotfound = styled.img``;
const Container = styled.div``;
const StakedContainer = styled.div``;
const TextWrapper = styled.div``;
const Text = styled.text`
  font-size: 32px;
  font-family: "SweraDemo";
  font-weight: 700;
`;
const NftWrapper = styled.div`
  background: linear-gradient(
    160.61deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 101.7%
  );
  border-width: 2.5px 0px;
  /* border-style: solid; */
  border-color: rgba(255, 255, 255, 0.4);
  -webkit-backdrop-filter: blur(17.915px);
  backdrop-filter: blur(17.915px);
  border-radius: 30px;
  /* padding: 30px 10px; */
`;
const NftNewArivalWrapper = styled.div`
  display: flex;
  display: flex;
  width: 90%;
  cursor: pointer;
  border-radius: 20px;
  background-color: #262a2d;
  margin: 5%;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  padding: 15px 0;
`;
const NftNewArival = styled.img`
  width: 200px;
  height: 152px;
  aspect-ratio: auto 200 / 152;
  cursor: pointer;
  transition: 0.5s;
  &:hover {
    transform: scale(1.3);
  }
`;
const NftNameWrapper = styled.div`
  margin: 10px 20px;
`;
const ListedImg = styled.img``;
const ListedTag = styled.div`
  position: absolute;
  top: 13px;
  left: 20px;
  border-radius: 50px;
  font-size: 11px;
  text-transform: lowercase;
  font-weight: 400;
  color: #545454;
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: absolute; */
  z-index: 9;
  /* box-shadow: 0px 0px 7px 5px #00000040; */
  /* &:after{
      content: "!";
    background-color: #fff;
    width: 20px;
    height: 20px;
    border-radius: 50px;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 17px;
    margin-left: 5px;
    } */
`;

const InfoSectionClick = styled.div`
  position: absolute;
  background-color: #fff;
  border-radius: 10px 10px 10px 0;
  padding: 10px 15px;
  bottom: 25px;
  left: 30px;
  color: #767676;
  font-size: 14px;
  font-family: lato;
  letter-spacing: 0.1px;
  max-width: 300px;
  width: 300px;
`;

const InfoIco = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 10px;
  cursor: pointer;
  filter: grayscale(1);
`;
const InfoIcoMain = styled.div`
  position: relative;
`;

const NftNameText = styled.text`
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  /* text-transform: capitalize; */
  color: #fff;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin: 20px 0;
  margin-top: 0;
  grid-gap: 20px;
  @media (max-width: 1600px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 1300px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

const LineWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #5d345d;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const DescriptionWrapper = styled.div`
  width: 90%;
  display: flex;
  justify-content: start;
  align-items: center;
  text-align: start;
  word-break: break-all;
`;
const DescriptionText = styled.text`
  text-align: justify;
  padding: 0 0px 0 20px;
  line-height: 18px;
  /* margin:10px 0 0 0; */
`;
const StakeTimeWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
  text-align: center;
  margin: 15px 10px;
`;

const StackTimeTextWrapper = styled.div`
  width: 40%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
`;

const StakeTimeText = styled.text`
  font-size: 20px;
  font-weight: 500;
`;
const StakeTimeValueWrapper = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: end;
`;

const StakeTimeValue = styled.text`
  font-size: 20px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const Button = styled.button`
  width: 90%;
  height: 55px;
  font-size: 18px;
  background: none;
  border: 1px solid #88fefe;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 50px;
  display: flex;
  outline: none;
  justify-content: center;
  align-items: center;
  color: #88fefe;
  font-weight: 500;
  cursor: pointer;
`;

const StakeButton = styled(Button)`
  position: relative;
  background: #e1e1e1;
  color: black;
  outline: none;
  border: none;
  transition: 0.5s;
  display: flex;
  flex-direction: row;
  &:hover {
    background: #b1b1b1;
    /* color: #208da5; */
  }
`;

// const TextContractContainer = styled.div`
//   margin: 1.5rem 0;
// `;
// const ContractTextWrapper = styled.div`
//   margin: 10px 0;
// `;

// const ContractText = styled.text`
//   font-size: 28px;
//   font-family: sans-serif;
//   font-weight: 500;
//   /* margin: 0 20px; */
// `;

// const PopUpTextWrapper = styled.div`
//   width: 100%;
// `;
// const PopupText = styled.input`
//   width: 100%;
//   font-size: 16px;
//   padding: 15px 15px;
//   background-color: rgba(255, 255, 255, 0.1);
//   border-radius: 8px;
// `;
// const SelectWrapper = styled.div``;
// const Select = styled.select`
//   width: 100%;
//   font-size: 16px;
//   padding: 15px;
//   background-color: rgba(255, 255, 255, 0.1);
//   border-radius: 8px;

//   cursor: pointer;
//   outline: none;
// `;

// const Option = styled.option`
//   width: 80%;
//   font-size: 16px;
//   padding: 15px 10px !important;
//   background-color: rgba(255, 255, 255, 0.1);
//   color: Black !important;
//   border-radius: 8px;

//   cursor: pointer !important;
//   outline: none;
// `;

// const RadioContainer = styled.div`
//   display: flex;
//   justify-content: flex-start;
//   align-items: center;
// `;

// const RadioButtonWrapper = styled.div`
//   font-size: 24px;
//   /* margin: 5px 20px; */
// `;

// const RadioButton = styled.input`
//   padding: 0 40px;
// `;

// const Span = styled.span`
//   margin: 15px 10px;
// `;
// const ButtonWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   text-align: Center;
//   justify-content: Center;
// `;

// const PopupButton = styled(Button)`
//   border: 1px solid #000;
//   color: #000;
// `;

const RarityContainer = styled.div`
  padding: 15px;
`;
const RarityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;
const RarityText = styled.text`
  margin: 10px 0;
`;
const NftNameIdWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
const NfIDWrapper = styled(NftNameWrapper)`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 0;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 90px;
  justify-content: center;
`;

const NftIDText = styled(NftNameText)``;
const NftCategory = styled.div`
  font-size: 9px;
  font-weight: 800;
  color: #74bccb;
  text-transform: uppercase;
  background-color: ${(props) =>
    props.common ? "#dddddd" : props.uncommon ? "#22363e" : "#22363e"};
  padding: 7px 12px;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
  right: 5px;
  ${(p) =>
    p.uncommon &&
    `
    background-color: #22363e;
    color: #74bccb;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #392e4a;
    color: #a98bc5;
  `};
`;

const MyNftsHomepage = ({ allContractDetails }) => {
  const debounceTimeout = useRef();
  const abortControllerRef=useRef();
  const [stakerDataList, setStakerList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [searchKey,setSearchKey]=useState("");
  const [isUserListed, setIsUserListed] = useState(false);
  const [selectFilter, setSelectFilter] = useState("all");
  const [activeLine, setActiveLine] = useState(null);
  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)

  const [address, setAddress] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [auction, setAuction] = useState(false);
  // const [price, setPrice] = useState("");
  const [success, setSuccess] = useState(false);
  const [currency, setCurrency] = useState("");
  const [listedItem, setListedItem] = useState();
  const navigation = useNavigate();
  const addInitiatedTransactions = async (contract, token) => {
    try {
      let data = {
        type: "buy",
        user_address: allContractDetails?.address,
        contract_address: contract,
        token_id: token,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_initiated_trxs`,
        headers:{
          authorization:`Bearer ${userAccInfo}`
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error, "initiated transaction error");
        });
    } catch (err) {
      console.log(err, "initiated transaction error");
    }
  };
  const AllListedDataHandle = () => {
    if(abortControllerRef.current){
      abortControllerRef.current.abort()
    }
  
    abortControllerRef.current= new AbortController();
    let searchFilters={};
    if(searchKey.length>=3){
      searchFilters.search=searchKey
    }
    if(selectFilter!=null&&selectFilter!=undefined&&selectFilter!="all"){
      searchFilters.filter=selectFilter;
    }
    if(activeLine!=null&&activeLine!=undefined&&activeLine!="all"){
      searchFilters.availability=activeLine;
    }
    axios
      .get(
        `${
          environmentVariables?.apiUrl
        }/nftmarketplace/api/v1/getmyallnfts/${allContractDetails?.address.toLowerCase()}`,
        { 
          signal: abortControllerRef.current.signal,
          params: searchFilters
        }
      )
      .then((res) => {
        // console.log("AllListedDataHandle", res.data.data[8]);
        setListedItem(res.data.data);
        // console.log(res.data.data)
        setLoading(false);
      })
      .catch((error) => {
        if(axios.isCancel(error)){
          console.log("Request canceled",error.message)
        }else{
          console.log(error)
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    setLoading(true);
    // getAllTheInformation();
  }, []);

  useEffect(() => {
    if (allContractDetails && allContractDetails?.metalordNFTManagerContract && allContractDetails?.address) {
      if(debounceTimeout.current) clearTimeout(debounceTimeout.current);
      let timeout=0;
      if(searchKey!=null&&searchKey!=undefined&&searchKey.trim()!=""){
        setLoading(false);
        timeout=1000;
      }
      debounceTimeout.current = setTimeout(() => {
        setLoading(true)
        AllListedDataHandle();
      isListedNFTs(allContractDetails?.address);
      }, timeout);
    }
  
      // getAllTheInformation();
      return ()=>{
        if(debounceTimeout.current) clearTimeout(debounceTimeout.current)
      }
  }, [allContractDetails,selectFilter,activeLine,searchKey]);

  //   useEffect(() => {
  //   if (allContractDetails && allContractDetails?.metalordNFTManagerContract&&allContractDetails?.address) {
  //     setLoading(true)
  //     AllListedDataHandle();
  //   isListedNFTs(allContractDetails?.address);
  //   // getAllTheInformation();
  //   }
  // }, [allContractDetails,selectFilter,activeLine]);

  const getAllNftMarketplaceList = async () => {
    setLoading(true);
    let i = 0;
    let arr = [];
    let supportArr = [];
    while (i !== null) {
      await allMetalordNFTContractsDeployed(
        allContractDetails?.metalordNFTManagerContract,
        i
      )
        .then(async (res) => {
          if (res !== null) {
            arr.push(res);

            await isSupportedNFT(
              allContractDetails?.metaspaceNFTMarketplaceContract,
              res
            )
              .then(async (allDetailsOfNft) => {
                /* console.log("isSupportedNFT", isSupportedNFT); */
                if (allDetailsOfNft === true) {
                  supportArr.push(res);
                }

                setShowCreatedPopup(false);
                i++;
              })
              .catch((err) => {
                setLoading(false);
                i = null;
              });
          }
        })
        .catch((err) => {
          setLoading(false);
          i = null;
        });
    }
    setLoading(false);

    return supportArr;
  };

  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails?.signer
    );
  };

  const fetchNftDetail = async (address, index, url) => {
    const response = await axios.get(`${url}${address}/${index}`);
    return response.data;
  };

  const getAllStakerData = async (address, url, allNftContract) => {
    const arr = [];
    for (let index = 0; index <= allNftContract.length - 1; index++) {
      const contractAdd = allNftContract[index];
      const nftContract = await getNFTContract(contractAdd);
      const balanceOfData = (await balanceOf(nftContract, address)) || 0;
      for (let index = 0; index < parseInt(balanceOfData); index++) {
        const tokenId = await getTokenOfOwnerByIndex(
          nftContract,
          address,
          index
        );
        try {
          const nftDetail = await fetchNftDetail(
            contractAdd.toLowerCase(),
            tokenId,
            url
          );
          arr.push({
            address: contractAdd,
            tokenID: parseInt(tokenId),
            nftDetail: nftDetail,
          });
        } catch (error) {
          console.log("error", error);
          arr.push({ address: contractAdd, tokenID: parseInt(tokenId) });
        }
      }
    }

    return arr;
  };

  const getAllTheInformation = async () => {
    setLoading(true);
    // const metaspaceBaseApiURL = await getMetaspaceBaseApiURL(allContractDetails?.nftStakingContract)
    const metaspaceBaseApiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`;
    const allSupportedNftContract = await getAllNftMarketplaceList();
    // console.log("allSupportedNftContract", allSupportedNftContract);
    const stakerList = await getAllStakerData(
      allContractDetails?.address,
      metaspaceBaseApiURL,
      allSupportedNftContract
    );

    // console.log("stakerList", stakerList);
    const arr = [];
    stakerList?.length > 0 &&
      stakerList.map(async (stake) => {
        // console.log("stake", stake);
        const stakeData = await fetchNftDetail(
          stake.address.toLowerCase(),
          stake.tokenID,
          metaspaceBaseApiURL
        );
        // console.log("stakeData", stakeData);
        arr.push({
          ...stake,
          stakeData,
        });
      });

    // console.log("arr inside a mynfts page", arr);
    setStakerList(stakerList);

    setLoading(false);
  };
  const isListedNFTs = (address) => {
    if (address == null || address == undefined || address.trim() == "") {
      return;
    } else {
      axios
        .get(
          `${
            environmentVariables?.apiUrl
          }/nftmarketplace/api/v1/check_user_listed_nfts/${address.toLowerCase()}`,
          {headers:{
            authorization:`Bearer ${userAccInfo}`
          }}
        )
        .then((response) => {
          console.log(response?.data?.success);
          setIsUserListed(response?.data?.success);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const callNftListing = async () => {
    const res = await isSupportedNFT(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      address
    );

    // console.log("res inside a callNftListing", res);
    if (res === true) {
      if (BigInt(price) > 0 && currency !== " ") {
        // For BigInt problem
        // console.log("res true and inside a if condition", currency, price);
        const updatedPrice = convertedMulPrice(currency, price);
        // console.log("updatedPrice", updatedPrice);
        // console.log("before listNft call");
        // console.log("address", address);
        // console.log("tokenId", tokenId);
        // console.log("currency", currency);
        // console.log(
        //   "updatedPrice.",
        //   parseInt(updatedPrice / 1000000000000000000)
        // );
        // console.log("auction", auction);

        // console.log(
        //   "before await listnft",
        //   allContractDetails?.metaspaceNFTMarketplaceContract,
        //   address
        // );
        const newPrice = BigInt(updatedPrice);
        await addInitiatedTransactions(address, tokenId);
        await listNFT(
          allContractDetails?.metaspaceNFTMarketplaceContract,
          address,
          tokenId,
          currency,
          newPrice,
          auction
        )
          .then(async (res) => {
            // console.log(" inside then...");
            if (res !== null) {
              //addpt: need to integrate listing api here and change the owner
              // console.log(" adding console in side ifff");
              axios
                .post(
                  `${
                    environmentVariables?.apiUrl
                  }/nftmarketplace/api/v1/update_listing_status/${address.toLowerCase()}/${tokenId}`,
                  {
                    currency: currency,
                    price: parseInt(updatedPrice / 1000000000000000000),
                    isFixed: auction,
                  },
                  {headers:{
                    authorization:`Bearer ${userAccInfo}`
                  }}
                )
                .then((Apiresponse) => {
                  // console.log("Apiresponse111111", Apiresponse);
                  axios
                    .get(
                      `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
                    )
                    .then((res) => console.log(res))
                    .catch((err) => console.log(err));

                  setSuccess(true);
                  setLoading(false);
                  setMessage("Your Nft has been listed.");
                  setShowCreatedPopup(true);
                })
                .catch((error) => {
                  console.log("error", error);
                });
            }
          })
          .catch((err) => {
            setLoading(false);
            setMessage(err.message || "Something went wrong");
            setShowCreatedPopup(true);
          });
      }
    }
  };

  const onConfirmClick = async () => {
    setLoading(true);
    setOpen(false);
    // console.log(price, "--------------------------price----------------------");
    // console.log(currency, "--------------------currency--------------------");
    // console.log(
    //   address,
    //   "-------------------------address-------------------- "
    // );
    if (price > 0 && currency !== "") {
      // console.log("price", price);
      try {
        const nftContract = await getNFTContract(address);

        // const ownerAddress = await ownerOf(nftContract, tokenId);

        // console.log('ownerAddress', ownerAddress)
        // console.log(' allContractDetails?.address',  allContractDetails?.address)
        // if (ownerAddress === allContractDetails?.address) {
        // console.log("inside if of the owner", nftContract);
        const getIsApprovedForAll = await isApprovedForAll(
          nftContract,
          allContractDetails?.address,
          metaspaceNFTMarketplaceAddress
        );

        // console.log("getIsApprovedForAll", getIsApprovedForAll);
        if (getIsApprovedForAll === true) {
          // console.log("inside if of getIsApprovedForAll is true");
          await callNftListing();
        } else {
          // console.log("inside if of getIsApprovedForAll is false ");
          await setApprovalForAll(nftContract, metaspaceNFTMarketplaceAddress,allContractDetails?.provider);

          await callNftListing();
        }
        // } else {
        //   setLoading(false);
        //   setMessage("you are not a owner user");
        //   setShowCreatedPopup(true);
        // }
      } catch (err) {
        // console.log("inside else catch block");
        setLoading(false);
        setMessage(err.message || "Something went wrong");
        setShowCreatedPopup(true);
      }
    } else {
      setLoading(false);
      // alert("Please field all fields.");
      toast.warning("please fill all the fields")
    }
  };

  return (
    <>
      {/* {loading && <Loading />} */}
      <Root>
        <NavSectionWrapper>
                  <FilterContainer>
                    <SearchWrapper>
                    <SearchIcon src={searchicon}/>
                    <SearchInput value={searchKey} onChange={(e)=>setSearchKey(e.target.value)} type="text" placeholder="Search here" />
                  </SearchWrapper>
                  <FilterWrapper>
                    <CategoriesFilter
                      selectFilter={selectFilter}
                      setSelectFilter={setSelectFilter}
                      showMobileFilter={selectFilter}
                      setShowMobileFilter={setSelectFilter}
                      setShowSubCatFilter={()=>{}}
                    />
                  </FilterWrapper>
                  </FilterContainer>
                  <NavSection>
                    <Link
                      selected={activeLine === "all"||activeLine==null}
                      onClick={() => setActiveLine(null)}
                    >
                      <H1 selected={activeLine === "all"||activeLine==null}>All </H1>
                    </Link>
        
                    <Link
                      selected={activeLine === "staked"}
                      onClick={() => setActiveLine("staked")}
                    >
                      <H1 selected={activeLine === "staked"}>Staked </H1>
                    </Link>
        
                    <Link
                      selected={activeLine === "listed"}
                      onClick={() => setActiveLine("listed")}
                    >
                      <H1 selected={activeLine === "listed"}>Listed </H1>
                    </Link>
                    {/* <Link
                      selected={activeLine === "rare"}
                      onClick={() => setActiveLine("rare")}
                    >
                      <H1 selected={activeLine === "rare"}>Rare </H1>
                    </Link>
                    <Link
                      selected={activeLine === "legendary"}
                      onClick={() => setActiveLine("legendary")}
                    >
                      <H1 selected={activeLine === "legendary"}>Legendary </H1>
                    </Link> */}
                  </NavSection>
                  
                </NavSectionWrapper>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularLoader />
          </div>
        ) : (
          <>
            <Container>
              <StakedContainer>
                {/* <TextWrapper>
                  <Text>NFT owned by user </Text>
                </TextWrapper> */}

                {!listedItem || listedItem.length == 0 ? (
                  <>
                    <NftnotfoundMain>
                      {/* <Nftnotfound src={NftnotfoundImg} /> */}
                      You Don't Have NFT's, Buy one to use in game!
                    </NftnotfoundMain>
                  </>
                ) : (
                  <GridContainer>
                    {listedItem?.map((listedData, index) => {
                      return (
                        <>
                          <NftWrapper>
                            <NftNewArivalWrapper
                              onClick={() =>
                                navigation(
                                  `/viewnft/${listedData?.contractAddress}/${listedData?.tokenId}`
                                )
                              }
                            >
                              <NftCategory
                                common={listedData?.category === "common"}
                                Uncommon={listedData?.category === "Uncommon"}
                              >
                                {listedData?.category=="uncommon"||listedData?.category=="Uncommon"?"rare":listedData?.category}
                              </NftCategory>
                              <NftNewArival
                                src={`${environmentVariables?.cdnUrl}${listedData?.skinId}.png`}
                              />
                            </NftNewArivalWrapper>
                            <NftNameIdWrapper>
                              <NftNameWrapper>
                                <NftNameText>
                                  {" "}
                                  {listedData?.name || "-"}{" "}
                                </NftNameText>
                              </NftNameWrapper>
                              <NfIDWrapper>
                                <NftIDText> # {listedData?.hash} </NftIDText>
                              </NfIDWrapper>
                            </NftNameIdWrapper>

                            {/* <DescriptionWrapper>
                              <DescriptionText>
                                {listedData?.description?.slice(0, 90)} ...
                              </DescriptionText>
                            </DescriptionWrapper> */}
                            {/* <Modal
                              aria-labelledby="modal-title"
                              aria-describedby="modal-desc"
                              open={open}
                              onClose={() => setOpen(false)}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Sheet
                                variant="outlined"
                                sx={{
                                  width: 600,
                                  borderRadius: "md",
                                  p: 3,
                                  boxShadow: "lg",
                                }}
                              >
                                <ModalClose
                                  variant="outlined"
                                  sx={{
                                    top: "calc(-1/4 * var(--IconButton-size))",
                                    right:
                                      "calc(-1/4 * var(--IconButton-size))",
                                    boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                                    borderRadius: "50%",
                                    bgcolor: "background.body",
                                  }}
                                />

                                <>
                                  <TextContractContainer>
                                    <ContractTextWrapper>
                                      <ContractText> Price </ContractText>
                                    </ContractTextWrapper>
                                    <PopUpTextWrapper>
                                      <PopupText
                                        type="number"
                                        placeholder="87,234"
                                        onChange={(e) => {
                                          setPrice(e.target.value);
                                        }}
                                      />
                                    </PopUpTextWrapper>
                                  </TextContractContainer>

                                  <TextContractContainer>
                                    <ContractTextWrapper>
                                      <ContractText> Currency </ContractText>
                                    </ContractTextWrapper>
                                    <SelectWrapper>
                                      <Select
                                        onChange={(e) => {
                                          // setCurrency(e.target.value);
                                          const selectedIndex =
                                            e.target.selectedIndex;
                                          const selectedOptionText =
                                            e.target.options[selectedIndex]
                                              .textContent;
                                          setCurrency(selectedOptionText);
                                        }}
                                      >
                                        <Option value="">
                                          Select Currency
                                        </Option>
                                        <Option value="0x0000000000000000000000000000000000001010">
                                          MATIC
                                        </Option>
                                        <Option value="0xc2132D05D31c914a87C6611C10748AEb04B58e8F">
                                          USDT
                                        </Option>
                                        <Option value="0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6">
                                          MLD
                                        </Option>
                                      </Select>
                                    </SelectWrapper>
                                  </TextContractContainer>

                                  <ButtonWrapper>
                                    <PopupButton
                                      onClick={() => {
                                        console.log(
                                          "adddress, tokenId, auction",
                                          address,
                                          tokenId,
                                          auction,
                                          price,
                                          currency
                                        );
                                        onConfirmClick();
                                      }}
                                    >
                                      Confirm
                                    </PopupButton>
                                  </ButtonWrapper>
                                </>
                              </Sheet>
                            </Modal> */}

                            <ButtonContainer
                              onClick={() => {
                                setAddress(listedData?.contractAddress);
                                setTokenId(listedData?.tokenId);
                                navigation(
                                  `/viewnft/${listedData?.contractAddress}/${listedData?.tokenId}`
                                );
                              }}
                            >
                              <StakeButton>
                                {" "}
                                View NFT
                                {listedData?.isListed == true ? (
                                  <ListedTag>
                                    <Tooltip
                                      text="NFT listed for sale !"
                                      isList={true}
                                    >
                                      <ListedImg src={ListedIcon} />
                                    </Tooltip>
                                    {/* Listed on marketplace */}
                                    {/* <InfoIcoMain>
                                      <InfoIco src={InfoIcon} />
                                    </InfoIcoMain> */}
                                  </ListedTag>
                                ) : (
                                  <></>
                                )}
                                {listedData?.isStaked == true ? (
                                  <ListedTag>
                                    <Tooltip text="NFT STAKED !" isList={false}>
                                      <ListedImg src={StakedIcon} />
                                    </Tooltip>
                                    {/* <InfoIcoMain>
                                      <InfoIco src={InfoIcon} />
                                    </InfoIcoMain> */}
                                  </ListedTag>
                                ) : (
                                  <></>
                                )}
                              </StakeButton>
                            </ButtonContainer>
                          </NftWrapper>
                        </>
                      );
                    })}
                  </GridContainer>
                )}
              </StakedContainer>
            </Container>
          </>
        )}
        {showCreatedPopup && success === true && (
          <ConfirmPopup
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            onClickFun={() => {
              setShowCreatedPopup(false);
            }}
            viewFun={() => {
              setShowCreatedPopup(false);
              if (auction === false) {
                //http://localhost:3000/viewnft/0x8fc3dec6148a9924870f205617c9c26b3010243e/144
                navigation(`/viewnft/${address.toLowerCase()}/${tokenId}`);
              } else {
                navigation(`/viewnft/${address.toLowerCase()}/${tokenId}`);
              }
            }}
            text={message}
          ></ConfirmPopup>
        )}
        {showCreatedPopup && success === false && (
          <ConfirmPopup
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            onClickFun={() => {
              setShowCreatedPopup(false);
            }}
            text={message}
          ></ConfirmPopup>
        )}
      </Root>
    </>
  );
};

export default MyNftsHomepage;
